"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOMAIN_SOURCES = void 0;
const DOMAIN_SOURCES = exports.DOMAIN_SOURCES = {
  EXACT_MATCH: 'exactMatch',
  ALTERNATE_TLD: 'alternateTld',
  TOP_LEVEL_CCTLD: 'topLevelCctld',
  TOP_LEVEL_COM: 'topLevelCom',
  TOP_LEVEL_EXACT_SLD_PREMIUM: 'topLevelExactSldPremium',
  TOP_PRIMARY_REG: 'topPrimaryReg',
  STACK_BUNDLE: 'stackBundle',
  AI_MODAL_EXACT_MATCH: 'aiModalExactMatch',
  AI_MODAL_SMART_EXACT: 'aiModalSmartExact',
  AI_SEARCH_TOP_RESULT: 'aiSearchTopResult',
  AI_SEARCH_SECOND_RESULT: 'aiSearchSecondResult',
  DOMAIN_PLUS: 'domainPlus'
};